export default __webpack_public_path__ + "images/LM.0731514.png";